// extracted by mini-css-extract-plugin
export default {"cta":"G121845","isDisabled":"G3e7db9","isFullWidth":"G3e2f0d"};